import React from 'react'
import {browserHistory} from 'react-router'
import {Button, Dialog} from 'react-weui'
import {isPC} from '../../utils'
import config from '../../config'


class LectureMode extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            showDialog: false,
            isRecordM: false,
            showPic: '',
            type: ''
        }
        this.setLiveType = this.setLiveType.bind(this)
    }
    setLiveType() {
        // 设置直播课
        this.setState({type: 'live'}, () => {this.props.clickHandle(2)})
    }
    getData() {
        return {type: this.state.type}
    }
    handleShowDialog(e) {
        if(e.target.dataset.value === '1'){
            this.setState({showPic:'https://static-1253442168.image.myqcloud.com/picture/6163344_c838efb2ef96dac23550fab777abfde1.jpg'})
        }else{
            this.setState({showPic:'https://static-1253442168.image.myqcloud.com/picture/6163344_e2922f396becd25f12319c4d7dcf47b2.jpg'})
        }
        this.setState({showDialog: true});
    }
    handleCloseDialog() {
        this.setState({showDialog: false});
    }
    onClickSuccessOk() {
        this.setState({showDialog: false});
        this.setState({isRecordM: false});
    }
    handleRecordClick() {
        if(isPC()) {
            let channelId = this.props.channelId
            if(channelId !== undefined){
                location.assign(`${config.ADMIN_BASE_URL}/channel/${channelId}`)
            }else{
                location.assign(`${config.ADMIN_BASE_URL}/channel/`)
            }
        }else{
            this.setState({showDialog: true});
            this.setState({isRecordM: true});
        }
    }
    render() {
        const {showDialog,isRecordM} = this.state;
        return (
            <div className="lecture-mode">
                <div className="lectureCreatePage--content">
                    <div>
                        <img src="https://static-1253442168.image.myqcloud.com/picture/6163344_dbcb4fe12e51612cdc7cd6dea23cecd5.jpg" />
                        <p className="modeTitle">互动直播</p>
                        <p className="modeWord">语音+图文互动直播，支持PPT和视频课件</p>
                        <Button className="btn_live" onClick={this.setLiveType}>创建直播课</Button>
                        <span onClick={(e) => this.handleShowDialog(e)} data-value="1">示例</span>
                    </div>
                    <div>
                        <img src="https://static-1253442168.image.myqcloud.com/picture/6163344_592a0d30288bbf0c8a6e9ac13b8452fc.jpg" />
                        <p className="modeTitle">图文录播</p>
                        <p className="modeWord">上传录制好的音频、视频，配上图文展示</p>
                        <Button type="primary" plain onClick={() => this.handleRecordClick()}>创建录播课</Button>
                        <span onClick={(e) => this.handleShowDialog(e)} data-value="2">示例</span>
                    </div>
                </div>
                {showDialog &&
                <div className="lectureCreatePage--dialog">
                    {!isRecordM &&
                    <div className="lectureDialog" onClick={this.handleCloseDialog.bind(this)}>
                        <img src={this.state.showPic} onClick={(e) => e.stopPropagation()}/>
                        <img src="https://static-1253442168.image.myqcloud.com/picture/6163344_7c67e5ae21bb976b6f1efbc91bf388c2.jpg" className="closeBtn" onClick={this.handleCloseDialog.bind(this)}/>
                    </div>
                    }
                    {isRecordM &&
                    <Dialog type="ios" title='' buttons={[
                        { label: <span style={{color:'#666'}}>知道了</span>, onClick: () => this.onClickSuccessOk() }
                    ]} show={true}>
                        此方式需用电脑登录讲师管理后台（{config.ADMIN_BASE_URL}）进行创建课程和上传音频、视频
                    </Dialog>
                    }
                </div>
                }
            </div>
        )
    }
}

export default LectureMode



// WEBPACK FOOTER //
// ./src/components/lectureCreate/LectureMode.js